<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="800px">
    <v-card>
      <v-form ref="addForm" @submit.prevent="add()">
        <v-toolbar tabs card color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('games.addTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-alert :value="tokens > -1" :color="tokens ? 'primary' : 'error'" outline>
            <h2 style="text-align: center">{{$tc('tokens.balance', this.tokens, {nbr: this.tokens})}}</h2>
          </v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 v-if="user.role > 2">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('games.test')"
                  v-model="test"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :label="$t('gameVersions.type')"
                  item-text="name"
                  item-value="value"
                  v-model="selectedType"
                  :items="types"
                  :rules="[v => v !== null || $t('fields.required')]"
                  :item-disabled="(val) => (val.value === 'dd' && this.tokens < config.ddTokenPrice || val.value === 'standard' && this.tokens < config.basicTokenPrice) && !test"
                ></v-select>
              </v-flex>
              <v-slide-y-reverse-transition>
                <v-flex xs12 v-if="selectedType">
                  <v-autocomplete
                    :label="$t('games.version')"
                    item-text="name"
                    return-object
                    v-model="currentModel.gameVersion"
                    :items="filteredGameVersions"
                    :rules="[v => !!v || $t('fields.required')]"
                  ></v-autocomplete>
                </v-flex>
              </v-slide-y-reverse-transition>
              <v-slide-y-reverse-transition>
                <v-flex xs12 v-if="selectedType && currentModel.gameVersion">
                  <v-text-field
                    :label="$t('games.name')"
                    v-model="currentModel.name"
                    :rules="[v => !!v || $t('fields.required')]"
                  ></v-text-field>
                </v-flex>
              </v-slide-y-reverse-transition>
              <v-flex xs12 v-if="currentModel.params">
                <v-card>
                  <v-toolbar dense card color="primary" dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{$t('gameVersions.params')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-switch
                          class="mt-0 mb-2"
                          hide-details
                          :label="$t('gameVersions.skipInstructions')"
                          v-model="currentModel.params.skipInstructions"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          class="mt-0 mb-2"
                          hide-details
                          :label="$t('gameVersions.timerActivated')"
                          v-model="currentModel.params.dayTimer"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 v-if="currentModel.params.dayTimer">
                        <v-text-field
                          :label="$t('gameVersions.timerCount')"
                          type="number"
                          v-model.number="currentModel.params.dayTimerCount"
                          :rules="[v => !!v || $t('fields.required')]"
                          :hint="$t('gameVersions.timerCountHint')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                          :label="$t('gameVersions.storageCost')"
                          type="number"
                          v-model.number="currentModel.params.storageCost"
                          :rules="[v => !!v || $t('fields.required')]"
                          hint
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                          :label="$t('gameVersions.delayCost')"
                          type="number"
                          v-model.number="currentModel.params.delayCost"
                          :rules="[v => !!v || $t('fields.required')]"
                          hint
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="currentModel.gameVersion.dd">
                        <v-text-field
                          :label="$t('gameVersions.weekNbrAutoCmj')"
                          type="number"
                          v-model.number="currentModel.params.weekNbrAutoCmj"
                          :rules="[v => !!v || $t('fields.required')]"
                          hint
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="currentModel.gameVersion.dd">
                        <v-text-field
                          :label="$t('gameVersions.changeBufferEveryNbrWeek')"
                          type="number"
                          v-model.number="currentModel.params.changeBufferEveryNbrWeek"
                          :rules="[v => !!v || $t('fields.required')]"
                          hint
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="currentModel.gameVersion.dd">
                        <v-select
                          :items="$store.getters['gameVersions/flowEquationDisplayModes']"
                          :label="$t('gameVersions.flowEquationDisplayModes.title')"
                          item-text="name"
                          item-value="number"
                          v-model="currentModel.params.flowEquationDisplay"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          readonly
                          :items="langsList"
                          :label="$t('general.language')"
                          v-model="currentModel.params.lang"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          :disabled="!currentModel.params || !currentModel.name || !selectedType || !currentModel.gameVersion"
            color="primary"
            :loading="$store.state.games.loading"
            type="submit"
            flat
          >{{$t('general.add')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.games.loading"
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Config from "@/config";
export default {
  name: "GameAdd",

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      test: false,
      selectedType: "",
      currentModel: {},
      rules: {
        required: value => !!value || this.$t("fields.required")
      },
      tokens: -1
    };
  },

  methods: {
    async init() {
      this.currentModel = Object.assign({}, this.$store.state.games.model);
      this.$store.dispatch("gameVersions/getAll");
      let res = await this.getTokenNumber(this.user.instance._id);
      this.tokens = res.tokens;
      await this.$nextTick();
      this.$refs.addForm.reset();
    },

    async add() {
      if (this.$refs.addForm.validate()) {
         this.currentModel.params.test = this.test
        this.currentModel.user = this.$store.state.user.current._id;
        this.currentModel.instance = this.user.instance._id
        if (await this.$store.dispatch("games/add", this.currentModel)) {
          this.$emit("closedialog");
        }
      }
    },

    ...mapActions("orders", {
      getTokenNumber: "getTokenNumber"
    })
  },

  computed: {
    types  () {
      return [
        {
          name: this.$t("gameVersions.standard") + ' (' + this.config.basicTokenPrice + ' ' + this.$tc("tokens.token", this.config.basicTokenPrice, {}) + ')',
          value: "standard"
        },
        {
          name: this.$t("gameVersions.dd") + ' (' + this.config.ddTokenPrice + ' ' + this.$tc("tokens.token", this.config.ddTokenPrice, {}) + ')',
          value: "dd"
        }
      ]
    },

    config () {
      return Config
    },

    filteredGameVersions () {
      return this.$store.state.gameVersions.list.filter((gameVersion) => {
        if (this.selectedType === "dd" && !gameVersion.dd) return false
        if (this.selectedType === "standard" && gameVersion.dd) return false
        return true
      })
    },

    ...mapGetters("user", {
      user: "current"
    }),

    ...mapGetters('interfaceSettings', {
      langsList: 'playerLangs'
    })
  },

  watch: {
    active(val) {
      if (val) {
        this.init();
      } else {
        this.selectedType = "";
      }
    },

    "currentModel.gameVersion"(val) {
      if (val.params) {
        this.currentModel.params = Object.assign({}, val.params);
      }
    }
  }
};
</script>
<style>
</style>

